import React from 'react'

export const available = ({ care_type, gov_person_registrations }) => (
  care_type.toLowerCase() === 'fdc' &&
  !gov_person_registrations.some(({ details }) => (
    details && details.CarerStatus === 'Active'
  ))
)

// eslint-disable-next-line react/display-name
const registerForm = ({ first_name }) => () => (
  <fieldset>
    Register {first_name} as a FDC carer.
  </fieldset>
)

const apiEndPoint = ({ gov_registration, personnel }) => (
  process.env.REACT_APP_API_HOST +
  `/api/gov-registrations/${gov_registration.gov_id}/personnel/${personnel.id}/carer-registration`

)

export const registerCarer = ({ gov_registration, personnel }) => (
  available(gov_registration) ?
    {
      label: 'Register as FDC carer',
      value: 'register_fdc_carer',
      component: registerForm(personnel),
      url: apiEndPoint({ gov_registration, personnel })
    } :
    null
)



// WEBPACK FOOTER //
// ./src/personnel/details/register-carer/index.js